import { render, staticRenderFns } from "./Contractors.vue?vue&type=template&id=5df8ac8c&scoped=true&"
import script from "./Contractors.vue?vue&type=script&lang=js&"
export * from "./Contractors.vue?vue&type=script&lang=js&"
import style0 from "./Contractors.vue?vue&type=style&index=0&id=5df8ac8c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8ac8c",
  null
  
)

export default component.exports